<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/engine/yangzhong/yz.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器扬中工厂
                </div>
                <div class="manufacture-t2">
                    位于江苏省扬中市，占地180亩，2020年6月首台发动机下线，2021年6月蜂巢第1000万台发动机下线；<br />
                    主要生产EB、EN发动机、缸体、缸盖、曲轴等产品；<br />
                    车间统一采用国际先进自动化设备，以柔性化、自动化、信息化的生产理念进行标准化的产品制造。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                机加车间
            </div>
            <div class="page-t2">
                专注发动机缸体、缸盖、曲轴三大核心部件，以国际顶尖装备与成熟工艺构建全流程智能制造体系，实现微米级精密制造与高效稳定交付。
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                精密装备
                            </div>
                            <div class="destils">
                                引进德国高端卧式加工中心、NAGEL 珩磨机、勇克及兰蒂斯高精磨床，定位精度≤0.004mm、重复定位精度≤0.002mm，保障超精磨削与复杂结构切削品质
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/yangzhong/yz1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                智能装夹
                            </div>
                            <div class="destils">
                                采用高精度零点销钉夹具，集成气密检测与断气自锁，实现零偏差换型、跨设备无缝流转
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/yangzhong/yz1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                智能制造与质量管控
                            </div>
                            <div class="destils">
                                ① 全产线自动化率 72.8%，防错覆盖率 97.8%<br />
                                ② 关键尺寸CPK≥1.67，综合良品率99.9%+，核心指标行业领先<br />
                                ③ 全流程数据追溯，生产履历接入 MES 系统，全程可溯、品质稳定
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/yangzhong/yz1-3.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                装试车间
            </div>
            <div class="page-t2">
                深度融合机器人集群、AI 视觉、物联网技术，以全流程数据驱动与纳米级工艺控制，打造发动机智能制造标杆。
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/yangzhong/yz2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                智能精密拧紧
                            </div>
                            <div class="destils">
                                采用库卡机器人 + Yamaha 伺服电机，实现关键部件微米级定位柔性拧紧，扭矩 - 角度双重闭环、毫秒级实时监控，质量稳定性行业领先
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/yangzhong/yz2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                全流程数据管控
                            </div>
                            <div class="destils">
                                MES 系统全覆盖，307 项生产数据实时交互，支持 10 年超长追溯；无线 + PLC 协同，100% 异常自动报警，制造过程透明可控
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/yangzhong/yz2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                全自动密封工艺
                            </div>
                            <div class="destils">
                                伺服电缸精准涂胶，激光实时监测胶线轨迹与尺寸，闭环管控，密封质量长效可靠
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/engine/yangzhong/yz2-4.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                高精度视觉与试漏防错
                            </div>
                            <div class="destils">
                                7 坐标五面视觉扫描，0.1mm 级偏差识别，30 项检测全覆盖，防错覆盖率 99%；<br />
                                双模高精度试漏，精度达0.01ml/min，气道、油道密封100% 全检，品质零隐患
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器扬中工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/en/yangzhong.html'
};

import { createApp } from 'vue';
import App from './yangzhong.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./yangzhong.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
